/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Time_Slots_Display_EmptyInputs */

const en_time_slots_display_empty = /** @type {(inputs: Time_Slots_Display_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No appointments available`)
};

const de_time_slots_display_empty = /** @type {(inputs: Time_Slots_Display_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Termine verfügbar`)
};

/**
* | output |
* | --- |
* | "No appointments available" |
*
* @param {Time_Slots_Display_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const time_slots_display_empty = /** @type {((inputs?: Time_Slots_Display_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Slots_Display_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_time_slots_display_empty(inputs)
	return en_time_slots_display_empty(inputs)
});